import Button from "@common/controls/Button/component";
import { IconType } from "@common/declarations";
import { last } from "lodash";
import React from "react";

type Breadcrumb = {
  reportId: string;
  reportName: string;
};

type BreadcrumbsProps = {
  breadcrumbs: Breadcrumb[];
  goTo?: (reportId: string) => void;
  name: string;
};
const Breadcrumbs = (props: BreadcrumbsProps) => (
  <div className="breadcrumbs">
    {props.goTo && (
      <Button type="white" onClick={(x) => props.goTo!(last(props.breadcrumbs)!.reportId)} icon={IconType.ArrowLeft} />
    )}

    {props.breadcrumbs.map((x, i) => (
      <React.Fragment key={x.reportId}>
        {i > 0 && <span>&nbsp;/&nbsp;</span>}
        <span className="item" onClick={props.goTo ? () => props.goTo!(x.reportId) : undefined}>
          {x.reportName}
        </span>
      </React.Fragment>
    ))}

    <span>&nbsp;/&nbsp;</span>
    <span className="item last">{props.name}</span>
  </div>
);

export default Breadcrumbs;
